var _ = require('underscore');
var LegendModelBase = require('./legend-model-base');

var CategoryLegendModel = LegendModelBase.extend({
  defaults: function () {
    return _.extend(LegendModelBase.prototype.defaults.apply(this), {
      type: 'category',
      categories: []
    });
  },

  getNonResettableAttrs: function () {
    return _.union(
      LegendModelBase.prototype.getNonResettableAttrs.apply(this),
      ['categories']
    );
  },

  isAvailable: function () {
    return this.get('categories') && this.get('categories').length > 0;
  }
});

module.exports = CategoryLegendModel;



//////////////////
// WEBPACK FOOTER
// ./~/internal-carto.js/src/geo/map/legends/category-legend-model.js
// module id = 1651
// module chunks = 6